import { useLayoutEffect } from "react";
import { reducedMotion } from "./smoothScroll";
import { splitWords } from "./splitWords";

// 페이지 등장 효과.
//  reveal: 아래에서 떠오를 요소 선택자 목록(ib-up)
//  split : 단어별로 올라올 제목 선택자 목록(ib-split)
// 화면 아래 8% 지점에 들어오면 나타나고, 같은 순간에 들어온 요소끼리는 위→아래·왼쪽→오른쪽 순서로 0.08초씩 늦게 나온다.
// 페이지 전환 막이 걷히는 중이면 0.22초 기다렸다 시작한다.
export function usePageMotion(rootRef, { reveal = [], split = [] } = {}) {
  useLayoutEffect(() => {
    const root = rootRef.current;
    if (!root || reducedMotion() || !("IntersectionObserver" in window)) return undefined;
    const targets = [];
    split.forEach((sel) =>
      root.querySelectorAll(sel).forEach((el) => {
        if (el.closest(".ib-split") && !el.classList.contains("ib-split")) return;
        splitWords(el);
        if (!targets.includes(el)) targets.push(el);
      })
    );
    reveal.forEach((sel) =>
      root.querySelectorAll(sel).forEach((el) => {
        if (targets.includes(el) || (el.closest(".ib-split") && !el.classList.contains("ib-up"))) return;
        el.classList.add("ib-up");
        targets.push(el);
      })
    );
    const io = new IntersectionObserver(
      (entries) => {
        const hits = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left);
        hits.forEach((e, k) => {
          e.target.style.setProperty("--d", `${Math.min(k, 6) * 0.08}s`);
          e.target.classList.add("is-up");
          io.unobserve(e.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px" }
    );
    const begin = () => targets.forEach((el) => io.observe(el));
    const wait = document.documentElement.classList.contains("ib-pt-run") ? setTimeout(begin, 220) : (begin(), 0);
    return () => {
      clearTimeout(wait);
      io.disconnect();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
